import { AlphaZIcon } from './AlphaZIcon';

/**
 * author: GreenTurtwig
 * id E82C7336-9ECE-4BA9-84BA-AA229FBF4E37
 * name alpha-z
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-z.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterZIcon = AlphaZIcon;
export default LetterZIcon